import * as React from "react";
const SvgTrash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="trash_svg__Calque_1"
    x={0}
    y={0}
    viewBox="0 0 150 150"
    width="1em"
    height="1em"
    {...props}
  >
    <style>
      {
        ".trash_svg__st0{fill:none;stroke:#232929;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}"
      }
    </style>
    <switch>
      <foreignObject
        width={1}
        height={1}
        x={0}
        y={0}
        requiredExtensions="http://ns.adobe.com/AdobeIllustrator/10.0/"
      />
      <g>
        <path
          d="M51.14 55.3h48.72M58.08 55.3l1.7 45.14c.03.82.74 1.48 1.59 1.48h27.55c.83 0 1.51-.63 1.55-1.42l2.13-45.19M66.36 62.35l2.2 32.95M85.14 62.35l-2.2 32.95M75.5 62.35V95.3"
          className="trash_svg__st0"
        />
        <path
          d="M68.56 55.3v-4.9c0-.86.73-1.56 1.63-1.56h11.13c.9 0 1.63.7 1.63 1.56v4.91"
          className="trash_svg__st0"
        />
      </g>
    </switch>
  </svg>
);
export default SvgTrash;
